<template>
  <div
    ref="rootTarget"
  >
    <navigation-link-component
      :data="item"
      :class="$style.root"
    >
      <template #default="{ title }">
        {{ title }}
      </template>
    </navigation-link-component>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const rootTarget = ref(null)

const scrollIntoView = () => {
  const nav = document.getElementById('nav')
  const navScrollWidth = nav?.scrollWidth
  const navWidth = nav?.getBoundingClientRect()?.width
  if (navScrollWidth >= navWidth) {
    const paddingLeft = rootTarget?.value?.firstChild ? parseInt(getComputedStyle(rootTarget?.value?.firstChild).paddingLeft) : 0
    const scrollLeft = nav?.scrollLeft
    const rootTargetLeft = rootTarget?.value?.getBoundingClientRect()?.x
    const left = rootTargetLeft + scrollLeft - paddingLeft
    nav?.scrollTo({top: 0, left: left, behavior: "smooth"})
  }
}

useMutationObserver(rootTarget, (mutations) => {
  for (const mutation of mutations) {
    if(mutation?.target?.classList?.contains("router-link-exact-active")) {
      scrollIntoView()
    }
  }
}, {
  attributes: true, childList: true, subtree: true
})

onMounted(() => {
  if (import.meta.client) {
    if (!rootTarget.value) { return }
    if (rootTarget?.value?.firstChild?.classList?.contains("router-link-exact-active")) {
      scrollIntoView()
    }
  }
})

</script>

<style module lang="scss">
.root {
  composes: button-rectangular font-size-large from global;

  background-color: var(--color--background);

  white-space: nowrap;
}
</style>
